import { ErsEntityConfig }  from '@app/modules/ers/presets/ers-entity-config.model';
import { RequestState }     from '@core/interfaces/api.interface';
import { IErsEntityEvents } from '@core/interfaces/entity.interface';
import {
	EntityActionEventEnum,
	EntityErrors,
	EntityVariantEnum
}                           from '@models/entity.model';


// ENUMS #############################################################
// API enums *********************************************************
export enum ErsDeviceTypeEnum {
	APP_POS = 'appPOS',
	CASH_REGISTER = 'cashRegister',
	DISTANCE_COUNTER = 'distanceCounter',
	PC_POS = 'pcPOS',
	TAXIMETER = 'taximeter'
}

export enum ErsStatusEnum {
	ACTIVE = 'active',
	DELETED = 'deleted',
	DISABLED = 'disabled',
	INACTIVE = 'inactive',
	SUSPENDED = 'suspended'
}

export enum ErsExternalStatusEnum {
	ACTIVE = 'active',
	DELETED = 'deleted',
	DISABLED = 'disabled',
	INACTIVE = 'inactive'
}

export enum ErsReportStateEnum {
	FAILED = 'failed',
	REQUESTED = 'requested',
	SUCCESS = 'success',
	SKIPPED = 'skipped'
}

// UI enums *********************************************************
export enum ErsPresetEnum {
	ERS = 'ers',
	ERS_EXTERNAL = 'ersExternal',
	BUSINESS_PREMISES_DETAIL_ERS = 'businessPremisesDetailErs',
	BUSINESS_PREMISES_DETAIL_ERS_EXTERNAL = 'businessPremisesDetailErsExternal'
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IErsEntityActionEvent {
	action: EntityActionEventEnum;
	ers: ErsVariant;
	ersEntityConfig: ErsEntityConfig;
}

// TYPES #############################################################
export type ErsProp = ( keyof Ers );
export type ErsProps = ErsProp[];
export type ErsExternalProp = ( keyof ErsExternal );
export type ErsExternalProps = ErsExternalProp[];

export type ErsVariantProp = ErsProp | ErsExternalProp;
export type ErsVariantProps = ErsProps | ErsExternalProps;
export type ErsVariant = Ers | ErsExternal;
export type ErsStatus = ErsExternalStatusEnum | ErsStatusEnum;


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
function CreateErsError(): Exclude<EntityErrors, 'invalidEntities'> {
	const entityErrors: EntityErrors = new EntityErrors();
	delete entityErrors.invalidEntities;

	return entityErrors as Exclude<EntityErrors, 'invalidEntities'>;
}

export class ErsBaseTMO {
	public acquisitionDate?: Date = undefined;
	public brand?: string = undefined;
	public businessPremisesId: string = undefined;
	public commissioningDate?: Date = undefined;
	public createdBy?: string = undefined;
	public createdDate?: Date = undefined;
	public deactivationDate?: Date = undefined;
	public deactivationReason?: string = undefined;
	public detailedDescription?: string = undefined;
	public deviceType?: ErsDeviceTypeEnum = undefined;
	public errors?: Exclude<EntityErrors, 'invalidEntities'> = CreateErsError();
	public ersIdentifier: string = undefined;
	public ersSerialNumber: string = undefined;
	public organizationId: string = undefined;
	public id: string = undefined;
	public lastModifiedBy?: string = undefined;
	public lastModifiedDate?: Date = undefined;
	public model?: string = undefined;
	public software?: string = undefined;
	public status?: ErsStatus = undefined;
	public submissionDisabledReportState?: ErsReportStateEnum = undefined;
	public taxOfficeRemark?: string = undefined;
	public version?: string = undefined;
}

export class ErsExternalTMO extends ErsBaseTMO {
	public extTssEntityId?: string = undefined;
	public status?: ErsExternalStatusEnum = undefined;
	public tssConnectionDate?: Date = undefined;
}

export class ErsTMO extends ErsBaseTMO {
	public activationDate?: Date = undefined;
	public decommissionDate?: Date = undefined;
	public firstConnectionEstablishedDate?: Date = undefined;
	public status?: ErsStatusEnum = undefined;
	public tssEntityId?: string = undefined;
	public type?: string = undefined;
}

export class ErsStatusStatisticsTMO {
	public active?: number = undefined;
	public disabled?: number = undefined;
	public suspended?: number = undefined;
	public inactive?: number = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class Ers extends ErsTMO {
	public readonly entityVariant?: EntityVariantEnum = EntityVariantEnum.INTERNAL;
	public etag?: string = undefined; // Additional UI App property for versioning

	public ui?: IErsEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}

export class ErsExternal extends ErsExternalTMO {
	public readonly entityVariant?: EntityVariantEnum = EntityVariantEnum.EXTERNAL;
	public etag?: string = undefined; // Additional UI App property for versioning
	public tssEntityId?: string = undefined;

	public ui?: IErsEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}


export class ErsStatusStatistics extends ErsStatusStatisticsTMO {}
